import { Tooltip } from '@/components';
import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';
import { formatNumber } from '../';

export const totalEstimatedCostColumnConfig = <T extends TableRow>(
  options?: Omit<TableColumn<T>, 'id' | 'label'>,
  className = 'max-w-[20vw] w-[20vw]',
): TableColumn<T> => ({
  id: 'totalEstimatedCost',
  label: <Trans i18nKey="estimated_cost_monthly" />,
  render: (value) => (
    <Tooltip showArrow content={`${formatNumber(value, 4)}€`}>
      {formatNumber(value)}€
    </Tooltip>
  ),
  acessorKey: 'totalEstimatedCost',
  sortable: false,
  className,
  ...options,
});
